module.exports = __webpack_public_path__ + "img/paper-with-lock-outline-blue.f3060c41.svg";